import { IUpdateTabStructure } from '../types/ITabUpdateStructure'

export const updateFormNavigationTabs: IUpdateTabStructure[] = [
  {
    title: 'Details',
    value: 'update_appointment_details',
    icon: 'circle-info',
  },
  { title: 'Notes', value: 'update_appointment_notes', icon: 'note' },
  { title: 'Print', value: 'update_appointment_print', icon: 'print' },
  { title: 'Delete', value: 'update_appointment_delete', icon: 'trash' },
]
